module.exports = __webpack_public_path__ + "img/ostado-tutor-signup-why3.acf9af3.gif";